import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuController, NavParams } from "@ionic/angular";
import { GlobalsService } from '../../api/globals.service';
import { ToastService } from '../../services/toast.service';
import { AuthConstants } from '../../config/auth-constants';
import { AuthService } from 'src/app/services/auth.service';

import  Epub, { EpubCFI }  from 'epubjs';
//import { AppComponent } from 'src/app/app.component';
import * as $ from 'jquery'
import { EbooksService } from 'src/app/services/ebooks.service';
import { EncriptadorService } from 'src/app/services/encriptador.service';
var Chapter:any = [];
 

@Component({
  selector: 'app-epub',
  templateUrl: './epub.component.html',
  styleUrls: ['./epub.component.scss'],
})
export class EpubComponent implements OnInit {
  @Input() file: string;
  ismobile: boolean;
  theme:string = '';
 


  public temasepub:string = "";

  public ChapterIon:any = [];
  public indexChapter:number;

  public epub:string;
  public type:string;
  public book: any;
  public fileE:string;
  public id_book;
  public rendition;

  displayUserData: any;
  auth_key:string;
  id_user:number;
  private init:number = 0;
  constructor(
    public globalsService: GlobalsService,
    public router:Router,
    private navParams:NavParams,
    private activeRoute:ActivatedRoute,
    private authService:AuthService,
    private ebooksService:EbooksService,
    private encriptService:EncriptadorService,
    //private gestureCtrl: GestureController,
  ) { 
    //this.initComponent();
  }

  initComponent() {}
  


   convertBlobToBase64 = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader;
    reader.onerror = reject;
    reader.onload = () => {
        resolve(reader.result);
    };
    reader.readAsDataURL(blob);
});



  ngOnInit() {
    
    this.ismobile = this.globalsService.isMobile;
    //console.log('ComponetEpub file: ',this.file);
    let ext =  this.file.split('.').pop();
    //console.log('EXT: ',ext);
    if(ext != 'epub'){
      return
    }
    //this.ePubComponent(this.file);
    this.authService.userData$.subscribe((res: any) => {
      this.displayUserData = res;
      
      let auth_key = this.displayUserData?.auth_key;
      this.id_user = this.displayUserData?.id;

      if (auth_key != undefined && this.init == 0) {
        this.init++;
        this.auth_key = this.displayUserData?.auth_key;
        this.ebooksService.getCompras(this.id_user,this.auth_key).subscribe((response) => {
          //console.log('response: ',response);
        });

        let jsondata = {'id_user':this.id_user,'auth_key':this.auth_key,'file':this.file,'tipo':ext,'id_pro':2}
        let encrypt = this.encriptService.encrypt(JSON.stringify(jsondata));
        this.ebooksService.getEbook(this.id_user,this.auth_key,encrypt).subscribe(async (response) => {
          
          let httpData:any =response;
          
            //let ebookFile = new File([httpData], this.file+'.epub', { type: 'application/epub+zip' });
            //let url = window.URL.createObjectURL(ebookFile);
            //console.log('URL: '+url);
            
          //console.log('Response: ',response);
          
        
        const base64String = await this.convertBlobToBase64(response);
        //console.log('base64String: ',base64String);
            this.ePubComponent(base64String);
          /*if(response.result){
            this.ePubComponent(response.data);
            this.auth_key = undefined;
          }/*** */
        });
      }
    });
    
  }

  ePubComponent(file){
    //console.log('Epub ready',file);
    let nameArr = file.split(',');
    
    let area = document.getElementById("area");
    let book:any = Epub(nameArr[1],{ encoding: "base64" });
    //let book:any = (Epub('http://localhost:8888/cronoleoyii2/compras/getepub'));
    let rendition = book.renderTo("area", {
      width: '100%',
      height: '100%',
      //ignoreClass: 'annotator-hl'
    });
    let displayed = rendition.display();
    displayed.then(function(renderer){
      
    });
    
    book.ready.then(function() {
      let next = document.getElementById("next");
      next.addEventListener("click", function(e){
        book.package.metadata.direction === "rtl" ? rendition.prev() : rendition.next();
        e.preventDefault();
      }, false);
  
      let prev = document.getElementById("prev");
      prev.addEventListener("click", function(e){
        book.package.metadata.direction === "rtl" ? rendition.next() : rendition.prev();
        e.preventDefault();
      }, false);
  
      let keyListener = function(e){
        // Left Key
        if ((e.keyCode || e.which) == 37) {
          book.package.metadata.direction === "rtl" ? rendition.next() : rendition.prev();
        }
        // Right Key
        if ((e.keyCode || e.which) == 39) {
          book.package.metadata.direction === "rtl" ? rendition.prev() : rendition.next();
        }
      };
      
      rendition.on("keyup", keyListener);
      document.addEventListener("keyup", keyListener, false);
      //********************* */
      rendition.themes.register("dark", {'body, p, a': {
        'background': '#111',
        'color':'white !important'
      }});
      rendition.themes.register("light", {'body, p, a': {
        'background': '#fff',
        'color':'rgb(22, 22, 22) !important'
      }});
      //rendition.themes.register("light", "/assets/epubcss/themes.css");
      //rendition.themes.register("tan", "/assets/epubcss/themes.css");
      rendition.themes.register("tan", {'body, p, a': {
        'background': 'tan',
        'color':'rgb(100, 100, 100) !important'
      }});
      //rendition.themes.select('tan');
      
      let darkTheme = document.getElementById("dark-theme");
      darkTheme.addEventListener("click", function(e){
        let event:any;
        event = e;
        let t = (event.target.getAttribute('data-theme'));
        rendition.themes.select(t);
        e.preventDefault();
      }, false);
      //let selectTheme = document.getElementById("select-theme");
      let lightTheme = document.getElementById("light-theme");
      lightTheme.addEventListener("click", function(e){
        let event:any;
        event = e;
        let t = (event.target.getAttribute('data-theme'));
        rendition.themes.select(t);
        e.preventDefault();
      }, false);
      let tanTheme = document.getElementById("tan-theme");
      tanTheme.addEventListener("click", function(e){
        let event:any;
        event = e;
        let t = (event.target.getAttribute('data-theme'));
        rendition.themes.select(t);
        e.preventDefault();
      }, false);

      rendition.on("relocated", function(location){
        //console.log(location);
        var next = book.package.metadata.direction === "rtl" ?  document.getElementById("prev") : document.getElementById("next");
        var prev = book.package.metadata.direction === "rtl" ?  document.getElementById("next") : document.getElementById("prev");
  
        if (location.atEnd) {
          next.style.visibility = "hidden";
        } else {
          next.style.visibility = "visible";
        }
  
        if (location.atStart) {
          prev.style.visibility = "hidden";
        } else {
          prev.style.visibility = "visible";
        }
  
      });
      /************ */
      book.loaded.navigation.then(function(toc){
        let select:any = document.getElementById("toc"),
            docfrag = document.createDocumentFragment();
        let index = 0;
        toc.forEach(function(chapter) {
          let option:any = document.createElement("option");
          option.textContent = chapter.label;
          option.ref = chapter.href;
          
          docfrag.appendChild(option);
          
          Chapter.push({'index':index,'label':option.innerText}) ;
          index++;
        });
        
        select.appendChild(docfrag);
        
        select.onchange = function(){
            let index = select.selectedIndex,
            url = select.options[index].ref;
            rendition.display(url);
            return false;
        };
    
      });

      /************************ */
      book.loaded.metadata.then(function(meta){
        let title:any = document.getElementById("title");
        let author:any = document.getElementById("author");
        let cover:any = document.getElementById("cover");
        let nav:any = document.getElementById('navigation');
  
        title.textContent = 'Título: '+meta.title + '';
        author.textContent = 'Autor: '+meta.creator;
        if (book.archive) {
          book.archive.createUrl(book.cover)
            .then(function (url) {
              cover.src = url;
            })
        } else {
          cover.src = book.cover;
        }
  
        if (nav.offsetHeight + 60 < window.innerHeight) {
          nav.classList.add("fixed");
        }
  
      });

    })
    /*********** */
    let tool = document.getElementById("btn-tool");
      tool.addEventListener("click", function(e){
        if( parseInt(document.getElementById("mySidenav").style.width) > 0 ){
          document.getElementById("mySidenav").style.width = "0px";
        document.getElementById("mySidenav").style.height = "100%";
        }else{
          document.getElementById("mySidenav").style.width = "250px";
        document.getElementById("mySidenav").style.height = "100%";
        }
        
        e.preventDefault();
      }, false);
      let closetool = document.getElementById("close-tool");
      closetool.addEventListener("click", function(e){
        document.getElementById("mySidenav").style.width = "0px";
        document.getElementById("mySidenav").style.height = "100%";
        e.preventDefault();
      }, false);
    /************** */
      let controlsFont:any = document.getElementById("controls-font");
      let currentPercent:any = document.getElementById("current-percent-font");
      let sliderFont:any = document.createElement("input");
      var percentF = 100;
      let slideFontFunction:any = function(){
        percentF = (sliderFont.value );
        currentPercent.value = percentF;
        console.log('percent',percentF);
        rendition.themes.fontSize(percentF+"%");
        //rendition.display(cfi);
      };
/************Slide font functions */
  book.ready.then(function(){
  controlsFont.style.display = "block";
  sliderFont.setAttribute("type", "range"); 
  sliderFont.setAttribute("style", "width: 100%"); 
  sliderFont.setAttribute("min", 40);
  sliderFont.setAttribute("max", 200);
  sliderFont.setAttribute("step", 1);
  
  sliderFont.setAttribute("value", 100);
  sliderFont.addEventListener("change", slideFontFunction, false);
  controlsFont.appendChild(sliderFont);
  sliderFont.value = percentF;
  currentPercent.addEventListener("change", function(){
    var pp = (currentPercent.value);
    sliderFont.value = pp;
    rendition.themes.fontSize(pp+"%");
  }, false);
});
/*************Fin Slide font function */
      /************ */
    let controls:any = document.getElementById("controls");
		let currentPage:any = document.getElementById("current-percent");
    let slider:any = document.createElement("input");
    
    let slide:any = function(){
      var cfi = book.locations.cfiFromPercentage(slider.value / 100);
      rendition.display(cfi);
  };
  var mouseDown = false;
      book.ready.then(function(){
        //rendition.annotations.highlight('epubcfi(/6/6[brief-toc]!/4/2/2/2,/1:6,/1:14)')
        // Load in stored locations from json or local storage
        var key = book.key()+'-locations';
        var stored = localStorage.getItem(key);
        //console.log('stored: ',stored);
        if (stored) {
           return book.locations.load(stored);
        } else {
          // Or generate the locations on the fly
          // Can pass an option number of chars to break sections by
          // default is 150 chars
          return book.locations.generate(1600);
        }
      })
      .then(function(locations){
          controls.style.display = "block";
          try {
            slider.setAttribute("type", "range"); 
            slider.setAttribute("style", "width: 100%"); 
          } catch (error) {
            
          }
          
          slider.setAttribute("min", 0);
          slider.setAttribute("max", 100);
          // slider.setAttribute("max", book.locations.total+1);
          slider.setAttribute("step", 1);
          
          slider.setAttribute("value", 0);
  
          slider.addEventListener("change", slide, false);
          slider.addEventListener("mousedown", function(){
              mouseDown = true;
          }, false);
          slider.addEventListener("mouseup", function(){
              mouseDown = false;
          }, false);
  
          // Wait for book to be rendered to get current page
          displayed.then(function(){
              // Get the current CFI
              var currentLocation = rendition.currentLocation();
              // Get the Percentage (or location) from that CFI
              var currentPage = book.locations.percentageFromCfi(currentLocation.start.cfi);
              console.log('FJTYFTYFU: ',currentLocation.start.cfi+','+currentLocation.end.cfi);
              /*book.getRange(currentLocation.start.cfi+','+currentLocation.end.cfi).then(function (range) {
                if(range)
                console.log('RANGE',range); 
                
                //rendition.annotations.highlight(range)
               })/**** */
              slider.value = currentPage;
              //currentPage.value = currentPage;
          });
          controls.appendChild(slider);
          currentPage.addEventListener("change", function(){
            var cfi = book.locations.cfiFromPercentage(currentPage.value/100);
            rendition.display(cfi);
          }, false);
          // Listen for location changed event, get percentage from CFI
          rendition.on('relocated', function(location){
              var percent = book.locations.percentageFromCfi(location.start.cfi);
              var percentage = Math.floor(percent * 100);
              //console.log('percentage: '+percent * 100);
              //var cfi = book.locations.cfiFromPercentage(slider.value / 100);
              if(!mouseDown) {
                  slider.value = percentage;
              }
              currentPage.value = percentage;
          });
          // Save out the generated locations to JSON
          localStorage.setItem(book.key()+'-locations', book.locations.save());
          //console.log('book.key(): '+book.key()+'-locations');
          /*let annH:any = JSON.parse(book.locations.save());
          console.log('element: ',(annH));
          annH.forEach(element => {
            //console.log('element: ',element);
            rendition.annotations.highlight(element)
          });/** */
          
          //console.log('book.locations.save(): ',book.locations.save());
          //console.log('localStorage: ',localStorage.getItem(book.key()+'-locations'));
          //localStorage.clear();
      });
      /************ */
      // Apply a class to selected text
      //let send = this.sendAjax();
      rendition.on("relocated", function(location){
        console.log('LOCATION:',location.start.cfi);
        var currentLocation = rendition.currentLocation();
        console.log('A_currentLocation result');
        console.log('A_currentLocation start.index: ',currentLocation.start.index);
        console.log('A_currentLocation end.index: ',currentLocation.end.index);
        //rendition.display(3);
      });
      
    rendition.on("selected", function(cfiRange, contents) {

      let view:any = contents;
      //var ann = new view.window.Annotator(view.document.body);
      console.log('selected view: ',view.document.body.firstElementChild);
      
      console.log('cfiRange: ',cfiRange);
      /*****TEST*** */
      //let doc = book.renderer.doc;
      let range;
      let textNode;
      let offset;
      let cfi;
      let annotation;
      let epubcfi:any = new EpubCFI();
      // standard
		
    console.log('textNode: ',textNode);
      /**FIN TEST** */
      //if(true)
      
      
      console.log('cfiRange',cfiRange);
      //rendition.annotations.highlight(cfiRange);
      rendition.annotations.highlight(cfiRange, {}, (e) => {
        console.log("highlight clicked", e.target);
      });/**** */
      //rendition.annotations.highlight('epubcfi(/6/14[Section0001.xhtml]!/4/50,/1:538,/1:2138)')
      //rendition.annotations.highlight('');
      book.getRange(cfiRange).then(function (range) {
        if(range){
          console.log('RANGE',range); 
          textNode = range.startContainer;
			    offset = range.startOffset;
          let endoffset = range.endOffset;
          let texto:string = textNode.nodeValue;
          console.log('nodeType: ',textNode.nodeType);
          console.log('Texto: ',texto);
          console.log('startOffset: ',offset);
          console.log('endoffset: ',endoffset);
          console.log('Texto seleccionado: ',texto.substring(offset,endoffset));
          
          let d = book.spine.get(cfiRange);
          console.log('d: ',d);
          //rendition.display('epubcfi(/6/8[xpreface_001]!/4/2/2/2/1:0)');
          
          //cfi = epubcfi.generateCfiFromTextNode(textNode, offset, rendition.currentChapter.cfiBase);
        }
        
        
        //rendition.annotations.highlight(range)
       })/***** */
      
      contents.window.getSelection();
      //contents.window.getSelection().removeAllRanges();
    });
    /*************** */
    /*************** */
    // Add several scripts / css
    rendition.hooks.content.register(function(contents){
      var loaded = Promise.all([
          contents.addScript("https://code.jquery.com/jquery-2.1.4.min.js"),
          //contents.addStylesheet("http://code.jquery.com/mobile/1.4.5/jquery.mobile-1.4.5.css")
          //contents.addStylesheet("/assets/css/jquery.mobile-1.4.5.css")
      ]);
      // return loaded promise
      return loaded;
  });
    /*************** */
    if(false)
    rendition.hooks.content.register(function (_view) {
      let view:any = _view;
      console.log('register-view: ',view);
      var adder = [
        ['.annotator-adder, .annotator-outer', ['position', 'fixed']]
      ];
      view.addScript('/assets/js/jquery.min.js').
        then(function () {
          return view.addScript('/assets/epubjs/annotator-full.min.js');
        }).
        then(function () {
          return view.addStylesheet('/assets/epubcss/annotator.min.css');
        }).
        then(function () {
          view.addStylesheetRules(adder);
          view.window.Annotator.Util.mousePosition = function(event) {
              var body = view.document.body;
              // var offset = view.position();
              return {
                  top: event.pageY,
                  left: event.pageX
              };
          };
          var ann = new view.window.Annotator(view.document.body);
          console.log('view.document.body',view.document.body);
        });
    })
  
    /*************** */
    this.ChapterIon = null;
    this.rendition = null;
    this.ChapterIon = Chapter;
    this.rendition = rendition;
    /*************** */
    
  }

  setTema(){
    console.log('setTema: ',this.temasepub);
    if(this.temasepub == 'dark'){
      document.getElementById("dark-theme").click();
    }else if(this.temasepub == 'light'){
      document.getElementById("light-theme").click();
    }else if(this.temasepub == 'tan'){
      document.getElementById("tan-theme").click();
    }
    
  }
  setChapter(){
    console.log('setChapter: ',this.indexChapter);
    let select:any = document.getElementById("toc");
    select.selectedIndex = this.indexChapter;
    let index = select.selectedIndex,
            url = select.options[index].ref;
            
            this.rendition.display(url);
  }

   sendAjax(){
    console.log('sendAjax...');
  }

  ngOnDestroy() {
    //this.init = 0;
  }
  
  
  

}
